import ko from './translations/ko.json';
import en from './translations/en.json';
export default {
  ko,
  en,
};
